import dayjs from "dayjs";

export const addZero = (number) => {
  if (number < 10) {
    return "0" + number.toString();
  }

  return number;
};

export const msToTimeLabel = (ms, separator) => {
  const seconds = ms / 1000;
  const minutes = ms / 1000 / 60;
  const s = seconds === 60 ? 0 : Math.floor(seconds > 60 ? seconds % 60 : seconds);
  const m = minutes === 60 ? 0 : Math.floor(minutes > 60 ? minutes % 60 : minutes);
  const h = Math.floor(ms / 1000 / 60 / 60);

  let out = separator ? addZero(s) : (addZero(s) + "s");
  out = (separator ? (addZero(m) + separator) : (addZero(m) + "m ")) + out;
  if (h) {
    out = (separator ? (addZero(h) + separator) : (addZero(h) + "h ")) + out;
  }
  return out;
};

export const convertToTime = (position) => {
  return msToTimeLabel(position * 1000, ":");
};

const SERVER_TIME_SEPARATOR = ":";
const SERVER_TIME_FORMAT = "HH" + SERVER_TIME_SEPARATOR + "mm" + SERVER_TIME_SEPARATOR + "ss";

const CLIENT_HOUR_SEPARATOR = ":";
const CLIENT_MINUTE_SEPARATOR = " ";
const CLIENT_TIME_FORMAT = "h" + CLIENT_HOUR_SEPARATOR + "mm" + CLIENT_MINUTE_SEPARATOR + "A";

export const formatServerTimeToTimeLabel = (time) => {
  if (time) {
    const [hourIn24Format, minute, second] = time.split(SERVER_TIME_SEPARATOR);
    return dayjs().hour(hourIn24Format).minute(minute).second(second).format(CLIENT_TIME_FORMAT);
  }

  return dayjs(new Date()).format(CLIENT_TIME_FORMAT);
};

export const parseServerTime = (time) => {
  const [hour12Format, minuteAndPeriod] = formatServerTimeToTimeLabel(time).split(CLIENT_HOUR_SEPARATOR);
  const [minute, period] = minuteAndPeriod.split(CLIENT_MINUTE_SEPARATOR);

  return [hour12Format, minute, period];
};

export const createServerTime = (hourIn24Format = 0, minute = 0, second = 0) => {
  return dayjs(new Date(0, 0, 0))
    .hour(hourIn24Format)
    .minute(minute)
    .second(second)
    .format(SERVER_TIME_FORMAT);
};